"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.groups.selectNumber': 'Numer telefonu',
    'whatsapp.groups.selectNumberPlaceholder': 'Wybierz numer telefonu...',
    'whatsapp.groups.loadFailed': 'Nie udało się załadować grup WhatsApp.',
    'whatsapp.groups.noGroups': 'Nie znaleziono grup. Uruchom agenta, aby zsynchronizować grupy WhatsApp.',
    'whatsapp.groups.trackingOn': 'Śledzenie aktywne',
    'whatsapp.groups.trackingOff': 'Brak śledzenia',
    'whatsapp.groups.loading': 'Ładowanie...',
    'whatsapp.groups.notFound': 'Nie znaleziono grupy.',
    'whatsapp.groups.info': 'Informacje o grupie',
    'whatsapp.groups.name': 'Nazwa',
    'whatsapp.groups.waId': 'ID WhatsApp',
    'whatsapp.groups.teleId': 'ID Telegram',
    'whatsapp.groups.phone': 'Numer telefonu',
    'whatsapp.groups.tracking': 'Włącz śledzenie wiadomości',
    'whatsapp.groups.pinMessage.label': 'Przypięta wiadomość',
    'whatsapp.groups.pinMessage.placeholder': 'Treść wiadomości do przypięcia w grupie...',
    'whatsapp.groups.pinMessage.hint': 'Gdy śledzenie jest włączone, a bot jest administratorem, ta wiadomość zostanie przypięta.',
    'whatsapp.groups.pinReminder.label': 'Wyślij ponownie przypiętą wiadomość',
    'whatsapp.groups.pinReminder.intervalLabel': 'Interwał (godziny)',
    'whatsapp.groups.pinReminder.hint': 'Wysyła ponownie przypiętą wiadomość, gdy od ostatniego przypomnienia pojawiło się co najmniej 10 nowych wiadomości.',
    'whatsapp.groups.tracking.badge': 'Śledzony',
    'whatsapp.groups.communicationType.wa': 'WA',
    'whatsapp.groups.communicationType.tele': 'TELE',
    'whatsapp.groups.trackingEnabled': 'Śledzenie wiadomości włączone.',
    'whatsapp.groups.trackingDisabled': 'Śledzenie wiadomości wyłączone.',
    'whatsapp.groups.trackingFailed': 'Nie udało się zaktualizować ustawień śledzenia.',
    'whatsapp.groups.messages': 'Śledzone wiadomości',
    'whatsapp.groups.noMessages': 'Brak śledzonych wiadomości.',
    'whatsapp.groups.openGroup': 'Otwórz grupę',
    'whatsapp.groups.back': 'Wróć',
    'whatsapp.groups.copyUrl.label': 'Kopiuj link publiczny',
    'whatsapp.groups.copyUrl.copied': 'Skopiowano!',
    'whatsapp.groups.copyUrl.title': 'Skopiuj publiczny link do tej grupy (z opcjonalnym filtrem numeru telefonu)',
    'whatsapp.groups.copyUrl.success': 'Publiczny link skopiowany do schowka.',
    'whatsapp.groups.copyUrl.failed': 'Nie udało się skopiować publicznego linku.',
    'whatsapp.groups.botSettings': 'Ustawienia bota',
    'whatsapp.groups.avatar': 'Awatar',
    'whatsapp.groups.selectAvatar': '-- Wybierz awatara --',
    'whatsapp.groups.botInstruction': 'Instrukcja bota',
    'whatsapp.groups.botInstructionPlaceholder': 'Wprowadź instrukcje dla bota WhatsApp...',
    'whatsapp.groups.saveSettings': 'Zapisz ustawienia',
    'whatsapp.groups.settingsSaved': 'Ustawienia zapisane pomyślnie.',
    'whatsapp.groups.settingsFailed': 'Nie udało się zapisać ustawień.',
    'whatsapp.groups.listTitle': 'Grupy WhatsApp',
    'whatsapp.groups.addGroup': 'Dodaj grupę',
    'whatsapp.groups.announce.label': 'Wszyscy użytkownicy mogą pisać w grupie',
    'whatsapp.groups.announce.hint': 'Gdy włączone, wszyscy członkowie grupy mogą wysyłać wiadomości (nie tylko administratorzy).',
    'whatsapp.groups.announce.saved': 'Tryb ogłoszeń zaktualizowany.',
    'whatsapp.groups.announce.failed': 'Nie udało się zaktualizować trybu ogłoszeń.',
    'whatsapp.groups.remoteAccess.label': 'Zdalny dostęp',
    'whatsapp.groups.accessPassword.label': 'Hasło dostępu',
    'whatsapp.groups.security.save': 'Ustaw zabezpieczenie',
    'whatsapp.groups.security.saved': 'Ustawienia zabezpieczeń zapisane.',
    'whatsapp.groups.security.failed': 'Nie udało się zapisać ustawień zabezpieczeń.',
    'whatsapp.groups.gate.title': 'Dostęp do grupy',
    'whatsapp.groups.gate.password': 'Hasło',
    'whatsapp.groups.gate.submit': 'Wejdź',
    'whatsapp.groups.gate.error': 'Nieprawidłowe hasło. Spróbuj ponownie.',
    'whatsapp.groups.gate.notAllowed': 'Ta grupa nie jest dostępna dla wybranego numeru telefonu.',
    'whatsapp.groups.dateFrom': 'Od',
    'whatsapp.groups.dateTo': 'Do',
    'whatsapp.groups.summarize': 'Podsumuj',
    'whatsapp.groups.summary': 'Podsumowanie',
    'whatsapp.groups.summaries.title': 'Podsumowania',
    'whatsapp.groups.summaries.empty': 'Brak podsumowań.',
    'whatsapp.groups.summaries.date': 'Data',
    'whatsapp.groups.summaries.view': 'Pokaż',
    'whatsapp.groups.summaries.excerpt': 'Streszczenie',
    'whatsapp.groups.summaries.modalTitle': 'Szczegóły podsumowania',
    'whatsapp.groups.summarizeDone': 'Podsumowanie wygenerowane pomyślnie.',
    'whatsapp.groups.summarizeFailed': 'Nie udało się wygenerować podsumowania.',
    'whatsapp.groups.syncMessages.button': 'Synchronizuj wiadomości',
    'whatsapp.groups.syncMessages.done': 'Wiadomości zsynchronizowane pomyślnie.',
    'whatsapp.groups.sendMessage.title': 'Wyślij wiadomość',
    'whatsapp.groups.sendMessage.placeholder': 'Wpisz wiadomość do grupy...',
    'whatsapp.groups.sendMessage.send': 'Wyślij',
    'whatsapp.groups.sendMessage.success': 'Wiadomość wysłana.',
    'whatsapp.groups.sendMessage.failed': 'Nie udało się wysłać wiadomości.',
    'whatsapp.groups.trackingDisabledHint': 'Śledzenie jest wyłączone dla tej grupy. Włącz śledzenie, aby przeglądać wiadomości, wysyłać wiadomości i przeglądać podsumowania.',
    'whatsapp.groups.syncMessages.failed': 'Nie udało się zsynchronizować wiadomości.',
    'whatsapp.groups.media.download': 'Pobierz',
    'whatsapp.groups.media.downloading': 'Pobieranie...',
    'whatsapp.groups.media.downloadFailed': 'Nie udało się pobrać pliku.',
    'whatsapp.groups.media.attachment': 'Załącznik',
    'whatsapp.groups.agentChecking': 'Sprawdzanie statusu agenta WhatsApp...',
    'whatsapp.groups.agentOffline': 'Agent WhatsApp jest offline. Wszystkie akcje wymagające połączenia z agentem są wyłączone.',
    'whatsapp.groups.loading_groups': 'Ładowanie grup...',
    'whatsapp.groups.members.title': 'Członkowie grupy',
    'whatsapp.groups.members.sync': 'Synchronizuj',
    'whatsapp.groups.members.syncFailed': 'Nie udało się zsynchronizować członków.',
    'whatsapp.groups.members.empty': 'Brak członków. Kliknij Synchronizuj, aby załadować z WhatsApp.',
    'whatsapp.groups.members.phone': 'Telefon',
    'whatsapp.groups.members.username': 'Nazwa użytkownika',
    'whatsapp.groups.members.id': 'WA ID',
    'whatsapp.groups.members.name': 'Nazwa',
    'whatsapp.groups.members.role': 'Rola',
    'whatsapp.groups.members.superAdmin': 'Super Admin',
    'whatsapp.groups.members.admin': 'Admin',
    'whatsapp.groups.members.member': 'Członek',
    'whatsapp.groups.members.promote': 'Mianuj administratorem',
    'whatsapp.groups.members.promoted': 'Członek mianowany administratorem.',
    'whatsapp.groups.members.promoteFailed': 'Nie udało się mianować członka.',
    'whatsapp.groups.addParticipants.title': 'Dodaj uczestników',
    'whatsapp.groups.addParticipants.phonePlaceholder': 'Wpisz numer telefonu...',
    'whatsapp.groups.addParticipants.addPhone': 'Dodaj numer',
    'whatsapp.groups.addParticipants.noPhonesYet': 'Nie dodano jeszcze numerów telefonów.',
    'whatsapp.groups.addParticipants.submit': 'Dodaj uczestników',
    'whatsapp.groups.addParticipants.success': 'Uczestnicy dodani pomyślnie.',
    'whatsapp.groups.addParticipants.failed': 'Nie udało się dodać uczestników.',
    'whatsapp.groups.members.remove': 'Usuń',
    'whatsapp.groups.members.removed': 'Członek usunięty z grupy.',
    'whatsapp.groups.members.removeFailed': 'Nie udało się usunąć członka.',
    'whatsapp.groups.members.feedBotData': 'Dane dla bota',
    'whatsapp.groups.members.allowBotUsage': 'Zezwól na użycie bota',
    'whatsapp.groups.members.updateFailed': 'Nie udało się zaktualizować ustawień członka.',
    'whatsapp.groups.joinGroup': 'Dołącz do grupy',
    'whatsapp.groups.joinLink.modalTitle': 'Dołącz do grupy WhatsApp',
    'whatsapp.groups.joinLink.hint': 'Wklej link zaproszenia do grupy WhatsApp (np. https://chat.whatsapp.com/...), a agent dołączy do tej grupy.',
    'whatsapp.groups.joinLink.label': 'Link zaproszenia',
    'whatsapp.groups.joinLink.placeholder': 'https://chat.whatsapp.com/...',
    'whatsapp.groups.joinLink.required': 'Wprowadź link zaproszenia.',
    'whatsapp.groups.joinLink.submit': 'Dołącz',
    'whatsapp.groups.joinLink.cancel': 'Anuluj',
    'whatsapp.groups.joinLink.success': 'Pomyślnie dołączono do grupy.',
    'whatsapp.groups.joinLink.failed': 'Nie udało się dołączyć do grupy.',
    'whatsapp.groups.trackLogs': 'Dziennik aktywności',
    'whatsapp.groups.trackLogs.noLogs': 'Brak wpisów w dzienniku aktywności.',
    'whatsapp.groups.trackLogs.logType.neutral': 'Neutralny',
    'whatsapp.groups.trackLogs.logType.good': 'Dobry',
    'whatsapp.groups.trackLogs.logType.warning': 'Ostrzeżenie',
    'whatsapp.groups.trackLogs.logType.critical': 'Krytyczny',
};
